import {
    FETCH_DELETE_COMMONS_REQUEST,
    FETCH_DELETE_COMMONS_SUCCESS,
    FETCH_DELETE_COMMONS_FAILURE,
} from '../../actions/commons/delete-common-action';

const initialState = {
    removed: null,
    isLoading: false,
    error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const DeleteCommonReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_DELETE_COMMONS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_DELETE_COMMONS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                removed: action.payload || true,
            };
        case FETCH_DELETE_COMMONS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default DeleteCommonReducer;